import type { SVGProps } from "react";
import * as React from "react";

export const UploadingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 15 16"
    {...props}
  >
    <g
      className="animate-loader-spin"
      style={{ transformOrigin: "center center", animationDuration: "2.5s", animationTimingFunction: "ease-in-out" }}
    >
      <path
        stroke="currentColor"
        strokeDasharray="2 4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M7.5 14.585a6.585 6.585 0 0 1 0-13.17"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M7.5 1.416a6.585 6.585 0 0 1 0 13.169"
      />
    </g>
    <g>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M7.5 10.927V5.439"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M10.06 8 7.5 5.44 4.94 8"
      />
    </g>
  </svg>
);
